import { useContext } from "react";
import { LocationContext } from "src/shared/context/location-context";
import { TopSubcategories } from "src/website-apps/responsive/stubhub-home/components/top-subcategories";
import { DateContext } from "src/website-apps/shared/context/date-context";

/**
 * Top Subcategories on Home Page Wrapper
 * TMHomeTopCategoryRedesign (17696) deployed variant — always render TopSubcategories.
 */
export const TopSubcategoriesOnHome = ({ size }) => {
  const [dates] = useContext(DateContext);
  const [userLocation] = useContext(LocationContext);
  return <TopSubcategories dates={dates} userLocation={userLocation} size={size} />;
};
